import { useState, useEffect, useCallback } from 'react';

const LOCAL_STORAGE_PREFIX = 'APP_';

function useLocalStorage(key) {
    const prefixedKey = `${LOCAL_STORAGE_PREFIX}${key}`;

    const [value, setValue] = useState(() => {
        try {
            const storedValue = localStorage.getItem(prefixedKey);
            return storedValue !== null ? storedValue : '';
        } catch (error) {
            console.error('Error accessing localStorage', error);
            return '';
        }
    });

    const saveValue = useCallback(
        newValue => {
            try {
                localStorage.setItem(prefixedKey, newValue);
                setValue(newValue);
            } catch (error) {
                console.error('Error writing to localStorage', error);
            }
        },
        [prefixedKey]
    );

    useEffect(() => {
        const handleStorageChange = event => {
            if (event.key === prefixedKey) {
                setValue(event.newValue || '');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [prefixedKey]);

    return [value, saveValue];
}

export default useLocalStorage;
